import React, { useEffect, useState } from 'react';
import { withPrefix } from 'gatsby';
import { Link } from 'gatsby';
/* --- import Components ----*/
import DropdownMenuItem from './DropdownMenuItem';
import MenuClosed from '../Icons/MenuClosed';
import MenuOpened from '../Icons/MenuOpened';
import HamburgerMenu from './HamburgerMenu';
import { AnchorButton } from '../Button';
import { Topbar } from '../Topbar';

/* --- import Utils ----*/
import { Manager, Reference, Popper } from 'react-popper';
import { useMediaQueries } from '../../utils/MediaQueries';
import { useTrackedSpring } from '../../utils/useTrackedSpring';
import { animated } from 'react-spring';
import throttle from 'lodash.throttle';

/* --- import Styles ----*/
import Theme from '../Theme';
import { MenuItem, MenuItemNotLink, SubMenuItem } from './elements';
import colors from 'src/style/colors';
import sizes from 'src/style/sizes';

/* --- import menu data --- */
import { TopBarMenuData } from 'src/data/TopBarData';

/**
 * @type React.FunctionComponent<{}>
 */

// function isTop() {
//   return global.window ? window.pageYOffset < 80 : true;
// }

const TopbarWithSubBar = React.memo(({ currentCoursePage, sectionScrolled, isBannerClosed }) => {
  const initialIsTop = true;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = TopBarMenuData.map((section) => {
    return { [section]: false };
  });
  const [popper, setPopper] = useState(menuItems);
  const initPopper = (sectionToToggle, open) => {
    const popperMenu = { ...menuItems };
    if (sectionToToggle) {
      popperMenu[sectionToToggle] = open || false;
    }
    setPopper(popperMenu);
  };
  const [selectedTab, setSelectedTab] = useState(false);

  const mqs = useMediaQueries();

  function isTop() {
    if (global.window) {
      if (isBannerClosed) {
        if (window.pageYOffset < 80) {
          return true;
        } else return false;
      } else if (window.pageYOffset < 80 - sizes.topbar.banner) {
        return true;
      } else return false;
    } else {
      return false;
    }
  }

  const anims = useTrackedSpring(
    (isTop) => ({
      height: isTop ? sizes.topbar.staticHeight : sizes.topbar.fixedHeight,
      top: isTop ? 110 : 70,
      transform: isTop ? 'translateY(-150%)' : 'translateY(0%)',
      heightBanner: mqs.phoneOnly ? 40 : 40,
      backgroundBanner: '#8A7DDE',
    }),
    initialIsTop,
    'white'
  );

  const previousOffset = React.useRef(global.window ? window.pageYOffset : 0);

  const update = () => {
    anims.setState(isTop());
    previousOffset.current = window.pageYOffset;
  };

  useEffect(() => {
    const handleScroll = throttle(() => {
      update();
    }, 1000 / 60);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  });

  useEffect(() => {
    update();
    // const cookiesBanner = () => {
    //   if (!Cookies.get('bannerHidden')) {
    //     setIsBannerClose(false);
    //   }
    // };
    // cookiesBanner();
  });

  useEffect(() => {
    if ((mqs.tabletLandscapeUp || mqs.desktopUp || mqs.bigDesktopUp) && isMenuOpen) {
      setIsMenuOpen(false);
    }
  }, [mqs.tabletLandscapeUp, mqs.desktopUp, mqs.bigDesktopUp, isMenuOpen]);

  return mqs.tabletLandscapeUp ? (
    <>
      <animated.div
        style={{
          height: anims.value.height,
        }}
        css={{
          position: 'fixed',
          zIndex: 1000,
          top: isBannerClosed || currentCoursePage === 'Alternance' ? 0 : sizes.topbar.banner,
          left: 0,
          right: 0,
          display: isTop() ? null : 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          background: colors.purple,
        }}
      >
        <div
          css={{
            maxWidth: 1350,
            padding: '20px',
            width: '100%',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <Link css={{ position: 'relative', marginRight: 10 }} to="/">
            <img
              css={{
                height: 37,
                zIndex: 2,
                opacity: 1,
                position: 'relative',
              }}
              src={withPrefix('/logo-le-reacteur.png')}
              alt="Le Reacteur - Logo"
            />
          </Link>
          <div css={{ flex: 1 }} />
          <Theme theme="primary">
            <div
              css={{
                display: mqs.tabletLandscapeUp ? 'flex' : 'none',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              {TopBarMenuData.map(({ section, elements, link, width, isActive }) => {
                if (isActive)
                  return (
                    <Manager key={section}>
                      <button
                        onMouseEnter={() => initPopper(section, true)}
                        onMouseLeave={() => initPopper(section)}
                      >
                        <Reference>
                          {({ ref }) =>
                            link ? (
                              <MenuItem to={link} ref={ref} withPadding={true}>
                                {section}
                              </MenuItem>
                            ) : (
                              <MenuItemNotLink ref={ref} withPadding={true}>
                                {section}
                              </MenuItemNotLink>
                            )
                          }
                        </Reference>
                        {popper[section] && elements?.length && (
                          <Popper placement="bottom">
                            {({ ref, style, placement }) => (
                              <animated.div
                                ref={ref}
                                style={style}
                                data-placement={placement}
                                css={{
                                  minWidth: 'fit-content',
                                  backgroundColor: colors.white,
                                  padding: '16px 16px 16px 16px',
                                  borderRadius: '5px',
                                  listStyle: 'none',
                                  boxShadow: '2px 2px 6px 1px rgba(0,0,0,0.20)',
                                  '&:before': {
                                    position: 'absolute',
                                    content: '""',
                                    top: '-5px',
                                    left: '50%',
                                    width: '11px',
                                    height: '11px',
                                    backgroundColor: colors.white,
                                    transform: 'translateX(-50%) rotate(45deg)',
                                    borderRadius: '2px',
                                    borderTop: '1px solid #F1F1F1',
                                    borderLeft: '1px solid #F1F1F1',
                                  },
                                }}
                              >
                                {elements
                                  .filter((el) => el.isActive !== false)
                                  .map((element, index) => {
                                    const { url, title, isNew, subtitle } = element;
                                    return (
                                      <DropdownMenuItem
                                        url={url}
                                        title={title}
                                        key={url}
                                        isNew={isNew || false}
                                        subtitle={
                                          <span>
                                            {subtitle.map(({ item, isBold }) => {
                                              return (
                                                <span
                                                  key={item}
                                                  css={{
                                                    fontWeight: isBold && 'bold',
                                                  }}
                                                >
                                                  {item}
                                                </span>
                                              );
                                            })}
                                          </span>
                                        }
                                      />
                                    );
                                  })}
                              </animated.div>
                            )}
                          </Popper>
                        )}
                      </button>
                    </Manager>
                  );
                else return null;
              })}
              <AnchorButton
                isSmall={true}
                to="/postuler"
                state={
                  currentCoursePage
                    ? { fromFormationsPage: { type: currentCoursePage } }
                    : undefined
                }
              >
                Postuler
              </AnchorButton>
            </div>
            <button
              css={{
                display: mqs.tabletLandscapeUp ? 'none' : 'block',
                height: 45,
                width: 55,
                position: 'relative',
                zIndex: 6,
              }}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <div
                css={{
                  display: mqs.tabletLandscapeUp ? 'none' : 'block',
                  position: 'absolute',
                  top: '50%',
                  right: 0,
                  transform: 'translateY(-50%)',
                }}
              >
                {isMenuOpen ? (
                  <MenuOpened colorFill={colors.white} />
                ) : (
                  <MenuClosed colorFill={colors.white} />
                )}
              </div>
            </button>
          </Theme>
        </div>
        <HamburgerMenu isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      </animated.div>

      <animated.div
        style={{ transform: anims.value.transform }}
        css={{
          position: 'fixed',
          zIndex: 90,
          top:
            isBannerClosed || currentCoursePage === 'Alternance'
              ? sizes.topbar.fixedHeight
              : sizes.topbar.fixedHeight + sizes.topbar.banner,
          left: 0,
          right: 0,
          height: 50,
          backgroundColor: colors.white,
          display: mqs.tabletLandscapeUp ? 'flex' : 'none',
          boxShadow: 'rgba(0, 0, 0, 0.06) 0px 0.2rem 0.5rem 0px',
        }}
      >
        <div
          css={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'flex-end',
            width: 1350,
            height: '100%',
            margin: '0 auto',
            padding: '0 20px',
          }}
        >
          {/* {mqs.desktopUp ? ( */}
          <SubMenuItem
            offset="100"
            href="#objectives"
            isSelectedTab={selectedTab}
            sectionScrolled={sectionScrolled}
            onClick={() => setSelectedTab('#objectives')}
          >
            Objectifs
          </SubMenuItem>
          {/* ) : null} */}
          <SubMenuItem
            offset="100"
            href="#next-sessions"
            isSelectedTab={selectedTab}
            sectionScrolled={sectionScrolled}
            onClick={() => setSelectedTab('#next-sessions')}
          >
            Prochaines sessions / Tarifs
          </SubMenuItem>
          {mqs.desktopUp && currentCoursePage !== 'E-Learning' ? (
            <SubMenuItem
              offset="100"
              href={currentCoursePage === 'Temps Plein' ? '#typical-day' : '#typical-week'}
              isSelectedTab={selectedTab}
              sectionScrolled={sectionScrolled}
              onClick={() =>
                setSelectedTab(
                  currentCoursePage === 'Temps Plein' ? '#typical-day' : '#typical-week'
                )
              }
            >
              {currentCoursePage === 'Temps Plein' ? 'Journée type' : 'Semaine type'}
            </SubMenuItem>
          ) : null}
          <SubMenuItem
            offset="100"
            href="#program"
            isSelectedTab={selectedTab}
            sectionScrolled={sectionScrolled}
            onClick={() => setSelectedTab('#program')}
          >
            Programme
          </SubMenuItem>
          <SubMenuItem
            offset="100"
            href="#admission"
            isSelectedTab={selectedTab}
            sectionScrolled={sectionScrolled}
            onClick={() => setSelectedTab('#admission')}
          >
            Admission
          </SubMenuItem>
          <SubMenuItem
            offset="100"
            href="#event-section"
            isSelectedTab={selectedTab}
            sectionScrolled={sectionScrolled}
            onClick={() => setSelectedTab('#event-section')}
          >
            Réunions d'information
          </SubMenuItem>

          <Link
            to="/financements/"
            state={{ fromFormationsPage: currentCoursePage }}
            css={{
              marginLeft: '32px',
              letterSpacing: 0.4,
              cursor: 'pointer',
              textDecoration: 'none',
              height: '100%',
              paddingTop: 13,
              fontStyle: 'normal',
              fontWeight: 500,
              color: colors.black,
              '&:hover': {
                color: colors.purple,
                transition: 'all 0.2s ease-in-out 0s',
                borderBottom: `3px solid ${colors.purple}`,
                borderRadius: '-5px',
              },
            }}
          >
            Financements
          </Link>
        </div>
      </animated.div>
    </>
  ) : (
    <Topbar currentCoursePage={currentCoursePage} isBannerClosed={isBannerClosed} />
  );
});

export default TopbarWithSubBar;
